import { ramos_nombres } from "./data";

const request_seguro = {
    // "CUIT": "20344185876"
    //"CUIT": "20217067244"
    CUIT: "20367780461",
    // "CUIT": "20298275385"
    // "CUIT": "20315062730"
    // "CUIT": "27302292081"
    //"CUIT": "30712385118"
    //"CUIT": "20264554951"
    //"CUIT": "20128928716"
};

//Ramos
const INCENDIO = ramos_nombres[1];
const COMBINADO_FAMILIAR = ramos_nombres[2];
const MOTOVEHICULOS = ramos_nombres[3];
const AUTOMOTORES = ramos_nombres[4];
const RESPONSABILIDAD_CIVIL = ramos_nombres[7];
const ACCIDENTES_PERSONALES = ramos_nombres[12];
const TRANSPORTES_CASCO = ramos_nombres[17];
const SEGURO_COLECTIVO_DE_VIDA = ramos_nombres[91];
const TRANSPORTE_TERRESTRE_DE_MERCADERIAS = ramos_nombres[18];
//Pdfs
const SORCA = "comprobante de seguro";
const POLIZA_COMPLETA = "poliza completa";
const CHEQUERA = "chequera";
const CERTIFICADO_COBERTURA = "certificado de cobertura";
const FACTURA_ELECTRONICA = "factura electrónica";

const pdf_ramos = {
    [POLIZA_COMPLETA]: [], //todos los ramos
    [CHEQUERA]: [], //todos los ramos
    [FACTURA_ELECTRONICA]: [], //todos los ramos
    [SORCA]: [COMBINADO_FAMILIAR, MOTOVEHICULOS, AUTOMOTORES],
    [CERTIFICADO_COBERTURA]: [ MOTOVEHICULOS, AUTOMOTORES],
};

//Tipo de pago
const EFECTIVO = "EFECTIVO";
const DEBITO_AUTOMATICO = "DEBITO AUTOMATICO";
const TARJETA_CREDITO = "CREDITO";

//Tipo seguro
const POLIZA = "poliza";
const ENDOSO = "endoso";

//Tipos de filtro
const RAMO = "ramo";
const TIPO_SEGURO = "tipo_seguro";

//Tipos de ordenamiento
const FECHA_EMISION = "fecha de emisión";
const DIAS_VIGENTES_RESTANTES = "proximo vencimiento";
const PREMIO = "premio";

const tipos_ordenamientos = [
    RAMO,
    FECHA_EMISION,
    DIAS_VIGENTES_RESTANTES,
    PREMIO,
];

//Pasos del formuilario de olvide contraseña
const FORGOT_PASSWORD_STEPS = {
    EMAIL_FORM_STEP: "EMAIL_FORM_STEP",
    VERIFICATION_CODE_FORM_STEP: "VERIFICATION_CODE_FORM_STEP",
    NEW_PASSWORD_FORM_STEP: "NEW_PASSWORD_FORM_STEP",
    SUCCESS_STEP: "SUCCESS_STEP",
};

export {
    INCENDIO,
    COMBINADO_FAMILIAR,
    MOTOVEHICULOS,
    AUTOMOTORES,
    RESPONSABILIDAD_CIVIL,
    ACCIDENTES_PERSONALES,
    TRANSPORTES_CASCO,
    SEGURO_COLECTIVO_DE_VIDA,
    TRANSPORTE_TERRESTRE_DE_MERCADERIAS,
    SORCA,
    POLIZA_COMPLETA,
    CHEQUERA,
    CERTIFICADO_COBERTURA,
    FACTURA_ELECTRONICA,
    EFECTIVO,
    DEBITO_AUTOMATICO,
    TARJETA_CREDITO,
    POLIZA,
    ENDOSO,
    RAMO,
    TIPO_SEGURO,
    FECHA_EMISION,
    DIAS_VIGENTES_RESTANTES,
    PREMIO,
    tipos_ordenamientos,
    pdf_ramos,
    request_seguro,
    FORGOT_PASSWORD_STEPS,
};
